import $ from 'jquery';
import React, { Component } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';



class Tare2 extends Component {

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        let sid = Context.GetContext().Sid;

        let data = Comm.CallServerFunction("scales/get_tare", { session: sid });




        this.Edit = this.Edit.bind(this);
        this.New = this.New.bind(this);
        this.Save = this.Save.bind(this);
        this.ChangeName = this.ChangeName.bind(this);
        this.ChangeWeight = this.ChangeWeight.bind(this);


        this.state = {
            Tares: data.result || [],
            name: null,
            weight: "",
            showMissingNameError: false
        };
    }



    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;


        let tares = this.state.Tares.slice();

        var self = this;
        console.log("render", this.state)


        return (

            Context.HasRight("rtare") ?
                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("tare")}</div>
                    <div className="panel-body">
                        {Context.HasRight("ctare") ?
                            <button className="btn btn-primary" onClick={this.New}>{Translation.Trans("newtare")}</button>
                            :
                            null
                        }
                        <br />
                        <br />
                        <br />
                        <div className="row">
                            <div className="col-md-5">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th width="90%">
                                                {Translation.Trans("name")}
                                            </th>
                                            <th width="10%">
                                            </th>

                                        </tr>
                                    </thead>
                                </table>
                                <div className="scrollableDiv">
                                    <table className="table table-striped">
                                        <tbody>

                                            {
                                                tares.map(obj =>
                                                    true ?
                                                        <tr>
                                                            <td width="90%">
                                                                <span className={this.state.name === obj.name ? "btn btn-warning" : null}>
                                                                    <a onClick={() => self.Edit(obj)} className="pointhand">{obj.name}</a>
                                                                </span>
                                                            </td>

                                                        </tr>
                                                        : null
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {
                                this.state.name !== null ?
                                    <div className="col-md-7 borderDiv">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label className="control-label">{Translation.Trans("name")}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <input type="text" className="form-control" value={self.state.name} onChange={this.ChangeName} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                {this.state.showMissingNameError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label className="control-label">{Translation.Trans("weight")}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <input type="number" className="form-control" value={self.state.weight} onChange={this.ChangeWeight} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                {this.state.showMissingWeightError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                            </div>
                                        </div>
                                        <div className="row">
                                            {Context.HasRight("utare") ?
                                                <div className="col-md-12">
                                                    <button className="btn btn-primary pull-right" onClick={this.Save}>{Translation.Trans("save")}</button>
                                                    <button className="btn btn-info pull-right" onClick={() => self.Del()}><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                </div>
                                                :
                                                null
                                            }

                                        </div>

                                    </div>
                                    :
                                    null

                            }


                        </div>
                    </div>
                </div >
                :
                <div>{Translation.Trans("noRights")}</div>
        );
    }


    Edit(obj) {

        this.setState({ name: obj.name, weight: obj.weight });

    }
    New() {
        this.setState({ name: "", weight: "" });
    }




    Save() {
        this.setState({ showMissingNameError: false, showMissingWeightError: false });
        var canSave = true;

        if (this.state.name === "") {
            this.setState({ showMissingNameError: true });
            canSave = false;
        }

        if (this.state.weight === "") {
            this.setState({ showMissingWeightError: true });
            canSave = false;
        }

        if (!canSave)
            return;
        let sid = Context.GetContext().Sid;
        let data = { session: sid, weight: parseInt(this.state.weight), name: this.state.name };

        console.log("data", data, this.state)

        Comm.CallServerFunction("scales/set_tare", data);

        data = Comm.CallServerFunction("scales/get_tare", { session: sid });


        this.setState({
            Tares: data.result,
            showMissingNameError: false,
            showMissingWeightError: false,
            name: null
        });




    }

    Del() {
        let self = this;
        if (window.confirm(Translation.Trans("pleaseconfirm"))) {

            let name = self.state.name;
            let sid = Context.GetContext().Sid;
            Comm.CallServerFunction("scales/del_tare", { session: sid, name: name });
            let data = data = Comm.CallServerFunction("scales/get_tare", { session: sid });
            self.setState({
                Tares: data.result,
                showMissingNameError: false,
                showMissingWeightError: false,
                name: null
            });
        }


    }

    ChangeName(e) {
        this.setState({ name: e.target.value });
        console.log("name", e.target.value)
    }
    ChangeWeight(e) {
        this.setState({ weight: e.target.value });
    }

}


export default Tare2;


// WEBPACK FOOTER //
// ./src/pages/tare2.js